<button type="button" class="current-realm-button" [matMenuTriggerFor]="menu">
  <img class="realm-icon" src="/assets/default/realm-switch.svg" alt="switch realm icon">
  {{ currentRealm?.name }}
  <img class="chevron-icon" src="/assets/default/right.svg" alt="">
</button>

<mat-menu #menu>
  <mat-selection-list [multiple]="false" hideSingleSelectionIndicator>
    @if (!multipleRealmTypes) {
      @for (realm of realms; track realm) {
        <mat-list-option (click)="selectRealm(realm)">
          {{ realm.name }}
        </mat-list-option>
      }
    } @else {
      @for (realmType of orderedRealmTypes; track realmType) {
        @if (realmsByType(realmType).length) {
          @if (realmType !== RealmType.Idaas) {
            <h4 class="realm-section-heading">
              {{ RealmTypePresentation(realmType) }}
            </h4>
          }
          @for (realm of realmsByType(realmType); track realm) {
            <mat-list-option (click)="selectRealm(realm)" class="realm-option">
              {{ realm.name }}
            </mat-list-option>
          }
        }
      }
    }
  </mat-selection-list>
</mat-menu>
